import React from 'react'
import Topbar from '../../components/Topbar/Topbar'
import { arrow_icon } from '../../assets/img'
import { useNavigate } from 'react-router-dom'

const EditDocumentMMC = () => {
    const navigate = useNavigate()
    return (
        <div>
            <Topbar header={"Properties"} subHead={"Requested"} />
            <div className='d-flex ac-jb'>
                <div className='d-flex ac-jb '>
                    <p onClick={() => { navigate("/propertie-req-edit", { state: { type: "edit", submit: "submit" } }) }} className='f3 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 prop-act-tab pointer'>Property Request</p>
                    <p className='f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 prop-line'></p>
                    <p onClick={() => { navigate("/doc-verfication-edit", { state: { type: "edit", submit: "submit" } }) }} className='f3 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 prop-act-tab pointer'>Document Verification</p>
                    <p className='f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 prop-line'></p>
                    <p className='f3 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 prop-on-tab'>MMC</p>
                </div>
            </div>
            <div className='d-flex flex-wrap gap-5 my-5'>
                <div className='col-md-5'>
                    <p className='f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1'>Amount Name</p>
                    <input className='input-box' name="userName" value={"897"}
                        type="text" placeholder='Amount Name' disabled />
                </div>
                <div className='col-md-5'>
                    <p className='f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1'>GST %</p>
                    <input className='input-box' name="userName" value={"18"}
                        type="text" placeholder='Gst %' disabled />
                </div>
                <div className='col-md-5'>
                    <p className='f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1'>Plan Days  </p>
                    <input className='input-box' name="userName" value={"25"}
                        type="text" placeholder='Plan Days' disabled />
                </div>
                <div className='col-md-5'>
                    <p className='f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1'>Total Amount </p>
                    <input className='input-box' name="userName" value={"999"}
                        type="text" placeholder='Total Amount ' disabled />
                </div>
            </div>
            {/* <div>
                <p className='f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1'>Bank Details </p>
                <p className='f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1'>Bank Name : <span className='f3'>Chennai Federal Bank</span> </p>
                <p className='f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1'>Branch : <span className='f3'>T.Nagar Branch</span> </p>
                <p className='f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1'>IFSC Code : <span className='f3'>CHENN001234</span> </p>
                <p className='f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1'>Account Holder Name : <span className='f3'>Mr.Arjun Krishnan</span> </p>
                <p className='f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1'>Account Number : <span className='f3'>234862738989</span> </p>
            </div> */}
            <div className='d-flex as-js gap-5 mt-5'>
                <div className='col-md-5'>
                    <p className='f4 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1'>Terms & Conditions  </p>
                    <div className='d-flex as-js gap-3 my-3'>
                        <img src={arrow_icon} className='back-arrow' alt="" />
                        <p className='f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 col-md-10'>All residents and guests are expected to treat each other with respect and courtesy</p>
                    </div>
                    <div className='d-flex as-js gap-3 my-3'>
                        <img src={arrow_icon} className='back-arrow' alt="" />
                        <p className='f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 col-md-10'>All residents and guests are expected to treat each other with respect and courtesy</p>
                    </div>
                </div>
                <div className='col-md-5'>
                    <p className='f4 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1'>Points</p>
                    <div className='d-flex as-js gap-3 my-3'>
                        <img src={arrow_icon} className='back-arrow' alt="" />
                        <p className='f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 col-md-10'>All residents and guests are expected to treat each other with respect and courtesy</p>
                    </div>
                    <div className='d-flex as-js gap-3 my-3'>
                        <img src={arrow_icon} className='back-arrow' alt="" />
                        <p className='f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 col-md-10'>All residents and guests are expected to treat each other with respect and courtesy</p>
                    </div>
                </div>
            </div>
            <div className="d-flex ac-je mt-5">
                {/* {type == "edit" && ( */}
                <button
                    onClick={() => navigate("/properties-doc-verfication")}
                    className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 "  >
                    Pay MMC
                </button>
                {/* )} */}
            </div>
        </div>
    )
}
export default EditDocumentMMC